import React from 'react';
import { ShoppingBag, ChevronRight, X } from 'lucide-react';
import './index.css'; // Relies on Header styles

const CartSelectionModal = ({ isOpen, onClose, carts, onSelectCart }) => {
  if (!isOpen) return null;

  return (
    <div className="cart-selection-overlay" onClick={onClose}>
      <div className="cart-selection-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cart-selection-header">
          <h3>Resume Your Order</h3>
          <button className="cart-selection-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="cart-selection-body">
          <p className="cart-selection-subtitle">
            You have active items at multiple branches. Select which cart to resume:
          </p>

          <div className="cart-selection-list">
            {carts.map((cart, index) => (
              <button
                key={index}
                className="cart-selection-item"
                onClick={() => onSelectCart(cart)}
              >
                <div className="cart-item-icon">
                  <ShoppingBag size={24} color="#ff6b35" />
                </div>
                <div className="cart-item-details">
                  <span className="cart-store-name">{cart.storeName}</span>
                  <div className="cart-item-meta">
                    <span className="cart-order-type">
                      {cart.orderType.charAt(0).toUpperCase() + cart.orderType.slice(1)}
                    </span>
                    <span className="cart-item-count">
                      {cart.itemCount} {cart.itemCount === 1 ? 'item' : 'items'}
                    </span>
                  </div>
                </div>
                <ChevronRight size={20} color="#999" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSelectionModal;
